@import 'styles/mixins';
@import 'styles/variables';

$default-margin-top: -2;
$nothing-padding-top: 10;

$h1-padding-top: 50;
$h1-padding-bottom: 10;
$h2-padding-top: 52;
$h2-padding-bottom: 4;
$h3-padding-top: 18;
$h3-padding-bottom: 4;
$table-padding-top: 8;
$table-padding-bottom: 4;
$download-padding-bottom: 4;
$subdoc-padding-bottom: 4;
$code_block-padding-top: 8;
$code_block-padding-bottom: 4;
$blockquote-padding-top: 26;
$blockquote-padding-bottom: 20;

.elementPresence {
  position: absolute;
  margin-top: #{$default-margin-top}px;
  margin-left: -84px;
  transition: all 0.4s;
  display: none;

  @include for-desktop-up {
    display: block;
  }
}

.after-code_block {
  padding-top: #{$code_block-padding-bottom}px;
}

.after-download {
  padding-top: #{$download-padding-bottom}px;
}

.after-subdoc {
  padding-top: #{$subdoc-padding-bottom}px;
}

.after-table {
  padding-top: #{$table-padding-bottom}px;
}

.table {
  padding-top: #{$table-padding-top}px;
}

.code_block {
  padding-top: #{$code_block-padding-top}px;
}

.h1 {
  margin-top: #{$default-margin-top + $h1-padding-top}px;

  &.after-nothing {
    margin-top: #{$default-margin-top + $nothing-padding-top}px;
  }

  &.after-h2 {
    margin-top: #{$default-margin-top + $h1-padding-top - $h2-padding-bottom}px;
  }

  &.after-h3 {
    margin-top: #{$default-margin-top + $h1-padding-top - $h3-padding-bottom}px;
  }

  &.after-blockquote {
    margin-top: #{$default-margin-top + $h1-padding-top - $blockquote-padding-bottom}px;
  }
}

.h2 {
  margin-top: #{$default-margin-top + $h2-padding-top}px;

  &.after-nothing {
    margin-top: #{$default-margin-top + $nothing-padding-top - 6}px;
  }

  &.after-h1 {
    margin-top: #{$default-margin-top + $h2-padding-top - $h1-padding-bottom}px;
  }

  &.after-h3 {
    margin-top: #{$default-margin-top + $h2-padding-top - $h3-padding-bottom}px;
  }

  &.after-blockquote {
    margin-top: #{$default-margin-top + $h2-padding-top - $blockquote-padding-bottom}px;
  }
}

.h3 {
  margin-top: #{$default-margin-top + $h3-padding-top}px;

  &.after-nothing {
    margin-top: #{$default-margin-top + $nothing-padding-top - 9}px;
  }

  &.after-h1 {
    margin-top: #{$default-margin-top + $h3-padding-top - $h1-padding-bottom}px;
  }

  &.after-h2 {
    margin-top: #{$default-margin-top + $h3-padding-top - $h2-padding-bottom}px;
  }

  &.after-blockquote {
    margin-top: #{$default-margin-top + $h3-padding-top - $blockquote-padding-bottom}px;
  }
}

.blockquote {
  margin-top: #{$default-margin-top + $blockquote-padding-top}px;

  &.after-nothing {
    margin-top: #{$default-margin-top + $nothing-padding-top}px;
  }

  &.after-h1 {
    margin-top: #{$default-margin-top + $blockquote-padding-top - $h1-padding-bottom}px;
  }

  &.after-h2 {
    margin-top: #{$default-margin-top + $blockquote-padding-top - $h2-padding-bottom}px;
  }

  &.after-h3 {
    margin-top: #{$default-margin-top + $blockquote-padding-top - $h3-padding-bottom}px;
  }
}
